import React, { Component } from 'react';
import './wrapper-card-info.style.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logoman from './man1.svg';
import logo_polygon from './Polygon.svg'
// import AnimatedNumber from "animated-number-react";
import AnimatedNumber from '../../../custom-lib/animate-number'



export default class WrapperCardInfo extends Component {

    state = {
        isLoaded: false,
    }

    formatValue = value => `${Number(value).toFixed()}`;
    render() {
        return (
            <div className="warpper-card-info grid-container-card-info--fit">
                <div className="grid-card-info-element">

                    <Container >
                        <Row className="content-container-card">
                            <Col xs="3" className="col-container-card"><img src={logoman} alt="" /></Col>
                            <Col xs="9" >
                                <Row><h1 className="name-card-element-dashboard">TOTAL CUSTOMERS</h1></Row>
                                <Row>
                                    <h2 className="content-card-element-dashboard">
                                            <AnimatedNumber
                                                value={43298}
                                                formatValue={this.formatValue}
                                                duration={1500}
                                            />
                                        </h2>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="grid-card-info-element">
                    <Container >
                        <Row className="content-container-card">
                            <Col xs="3" className="col-container-card"><img src={logo_polygon} alt="" /></Col>
                            <Col xs="9" >
                                <Row><h1 className="name-card-element-dashboard">TOTAL DMA</h1></Row>
                                <Row> <h2 className="content-card-element-dashboard">
                                    <AnimatedNumber
                                        value={20}
                                        formatValue={this.formatValue}
                                        duration={500}
                                    />
                                </h2></Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="grid-card-info-element">
                    <Container >
                        <Row className="content-container-card">
                            <Col xs="3" className="col-container-card"><img src={logoman} alt="" /></Col>
                            <Col xs="9" >
                                <Row><h1 className="name-card-element-dashboard">TOTAL CUSTOMERS</h1></Row>
                                <Row> <h2 className="content-card-element-dashboard"> 
                                <AnimatedNumber
                                    value={365}
                                    formatValue={this.formatValue}
                                    duration={800}
                                />
                                </h2></Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="grid-card-info-element">
                    <Container >
                        <Row className="content-container-card">
                            <Col xs="3" className="col-container-card"><img src={logo_polygon} alt="" /></Col>
                            <Col xs="9" >
                                <Row><h1 className="name-card-element-dashboard">TOTAL CUSTOMERS</h1></Row>
                                <Row> <h2 className="content-card-element-dashboard"> 
                                <AnimatedNumber
                                    value={279}
                                    formatValue={this.formatValue}
                                    duration={750}
                                />
                                </h2></Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}
